module.exports = __webpack_public_path__ + "static/twitter-ce41e2410dda009f1e2dd34a671bc336.png";